import { render } from "./ProjectSummaryDraft.vue?vue&type=template&id=57a86628"
import script from "./ProjectSummaryDraft.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryDraft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__